import React from 'react';

function LoginGoogle() {
  const handleLoginGoogle = () => {
    window.location.href = "https://interventi.synology.me:5050/google-auth/login";
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '50px' }}>
      <h1>Accesso Google Calendar</h1>
      <p>Effettua il login con Google per sincronizzare il tuo calendario.</p>
      <button 
        onClick={handleLoginGoogle}
        style={{
          padding: '12px 24px',
          fontSize: '18px',
          borderRadius: '8px',
          border: 'none',
          backgroundColor: '#4285F4',
          color: 'white',
          cursor: 'pointer',
          marginTop: '20px'
        }}
      >
        Accedi con Google
      </button>
    </div>
  );
}

export default LoginGoogle;
